<script lang="ts">
	import * as Breadcrumb from '$lib/components/ui/breadcrumb'

	export let links: {
		href?: string
		text: string
	}[] = []
</script>

<Breadcrumb.Root class="mb-4 max-w-full overflow-x-auto md:p-1 lg:mb-6">
	<Breadcrumb.List itemscope itemtype="http://schema.org/BreadcrumbList">
		{#each links as { text, href }, idx (href)}
			<Breadcrumb.Item itemprop="itemListElement" itemscope itemtype="http://schema.org/ListItem">
				{#if typeof href === 'string'}
					<Breadcrumb.Link {href} itemprop="item">
						<span itemprop="name">{text}</span>
					</Breadcrumb.Link>
				{:else}
					<Breadcrumb.Page class="w-auto truncate" itemprop="name">
						{text}
					</Breadcrumb.Page>
				{/if}

				<meta content={idx.toString()} itemprop="position" />
			</Breadcrumb.Item>

			{#if idx !== links.length - 1}
				<Breadcrumb.Separator />
			{/if}
		{/each}
	</Breadcrumb.List>
</Breadcrumb.Root>
